// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Vicesoftware
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Vicesoftware
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */.pb-defaults-form .mat-form-field,.pb-defaults-form .mat-mdc-form-field{min-width:160px;max-width:160px}.pb-defaults-form .mat-form-field.field.one-third,.pb-defaults-form .mat-mdc-form-field.field.one-third{min-width:140px;max-width:140px}`, "",{"version":3,"sources":["webpack://./packages/builder-estimating/price-books/components/price-book-details/pb-details-defaults-form/pb-details-defaults-form.component.scss"],"names":[],"mappings":"AAAA;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAQE,wEAEE,eAAA,CACA,eAAA,CAEA,wGACE,eAAA,CACA,eAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Vicesoftware\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n.pb-defaults-form {\n  .mat-form-field,\n  .mat-mdc-form-field {\n    min-width: 160px;\n    max-width: 160px;\n\n    &.field.one-third {\n      min-width: 140px;\n      max-width: 140px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
